import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Tabs, Tab } from "react-bootstrap";
import { Table } from "reactstrap";
import Moment from "moment";
import { apiFetch, API } from "../services/api";
import { winnersCSV } from "../helpers/challengeShop";
import { safeHref } from "../helpers/safeHref";

// Boutique, loterie et paniers 1 minute d'un challenge en mode « shop » (spec 2026-10-16) :
// achats à valider / refuser, urne et tirage (définitif), remplacement d'un gagnant, paniers.

const STATUS = { pending: "En attente", validated: "Validé", refused: "Refusé" };

async function call(path, options) {
    const res = await apiFetch(API.back + path, options || { method: 'GET' });
    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
    if (!res.ok) throw new Error((data && data.message) || `Erreur ${res.status}`);
    return data;
}

const post = (path, body) => call(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export default class ChallengeShopLottery extends Component {
    state = { purchases: null, draws: [], baskets: [], entries: {}, error: null, busy: null, onlyPending: true, testLink: "" };

    componentDidMount() {
        this.refresh();
    }

    id = () => this.props.challenge.id;

    refresh = () => {
        const id = encodeURIComponent(this.id());
        Promise.all([call('/challenge-purchases?id=' + id), call('/challenge-draws?id=' + id), call('/challenge-baskets?id=' + id)])
            .then(([purchases, draws, baskets]) => this.setState({ purchases: purchases || [], draws: draws || [], baskets: baskets || [], error: null }))
            .catch(e => this.setState({ error: e.message }));
    };

    loadEntries = (date) => call(`/challenge-draw-entries?id=${encodeURIComponent(this.id())}&date=${date}`)
        .then(v => this.setState(prev => ({ entries: { ...prev.entries, [date]: v } })))
        .catch(e => this.setState({ error: e.message }));

    decide = (p, decision) => {
        let reason = "";
        if (decision === "refuse") {
            reason = window.prompt(`Motif du refus pour ${p.displayName} (envoyé au participant) :`) || "";
            if (!reason.trim()) return;
        }
        this.setState({ busy: p.purchaseId });
        post('/challenge-purchase-decision', { id: this.id(), userID: p.userID, purchaseId: p.purchaseId, decision, reason })
            .then(this.refresh)
            .catch(e => this.setState({ error: e.message }))
            .finally(() => this.setState({ busy: null }));
    };

    draw = (date) => {
        if (!window.confirm(`Lancer le tirage du ${date} ? Le résultat est DÉFINITIF et les gagnants seront notifiés.`)) return;
        this.setState({ busy: `draw-${date}` });
        post('/challenge-draw', { id: this.id(), date })
            .then(this.refresh)
            .catch(e => this.setState({ error: e.message }))
            .finally(() => this.setState({ busy: null }));
    };

    replace = (date, w) => {
        if (!window.confirm(`Remplacer ${w.displayName} (lot ${w.prizeId}) par un nouveau tirage ? Les gagnants déjà tirés sont exclus.`)) return;
        this.setState({ busy: `replace-${date}-${w.userID}` });
        post('/challenge-draw-replace', { id: this.id(), date, prizeId: w.prizeId, userID: w.userID })
            .then(this.refresh)
            .catch(e => this.setState({ error: e.message }))
            .finally(() => this.setState({ busy: null }));
    };

    testBasket = () => {
        this.setState({ busy: "test-basket" });
        post('/challenge-basket-test', { id: this.id() })
            .then(r => this.setState({ testLink: (r && r.link) || "" }))
            .catch(e => this.setState({ error: e.message }))
            .finally(() => this.setState({ busy: null }));
    };

    exportWinners = () => {
        const labels = {};
        ((this.props.challenge.lottery && this.props.challenge.lottery.draws) || []).forEach(d => (d.prizes || []).forEach(p => { labels[p.id] = (p.label || {}).fr || p.id; }));
        const blob = new Blob([winnersCSV(this.state.draws, labels)], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `challenge-${this.id()}-gagnants-${Moment().format("YYYY-MM-DD")}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    renderPurchases() {
        const { purchases, busy, onlyPending } = this.state;
        if (!purchases) return <p>Chargement ...</p>;
        const items = {};
        (this.props.challenge.tiers || []).forEach(t => { items[t.rewardId] = (t.label || {}).fr || t.rewardId; });
        const list = onlyPending ? purchases.filter(p => p.status === "pending") : purchases;
        return (
            <>
                <Form.Check type="checkbox" id="only-pending" label={`En attente seulement (${purchases.filter(p => p.status === "pending").length})`}
                            checked={onlyPending} onChange={(e) => this.setState({ onlyPending: e.target.checked })} />
                <Table responsive size="sm">
                    <thead><tr><th>Date</th><th>Participant</th><th>Email</th><th>Lot</th><th>Prix</th><th>Statut</th><th></th></tr></thead>
                    <tbody>
                    {list.map(p => (
                        <tr key={p.userID + p.purchaseId}>
                            <td>{Moment(p.createdAt).format("DD/MM HH:mm")}</td>
                            <td>{p.displayName}</td>
                            <td>{p.email}</td>
                            <td>{items[p.rewardId] || p.rewardId}</td>
                            <td>{p.price} miles</td>
                            <td title={p.reason ? `Motif : ${p.reason}` : (p.decidedBy ? `par ${p.decidedBy}` : "")}>{STATUS[p.status] || p.status}{p.status !== "pending" && p.notifiedStatus !== p.status ? " (email en attente)" : ""}</td>
                            <td>
                                {p.status === "pending" ? (
                                    <>
                                        <Button size="sm" variant="outline-success" disabled={busy === p.purchaseId} onClick={() => this.decide(p, "validate")}>Valider</Button>{" "}
                                        <Button size="sm" variant="outline-danger" disabled={busy === p.purchaseId} onClick={() => this.decide(p, "refuse")}>Refuser</Button>
                                    </>
                                ) : null}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                <p className="text-muted" style={{ fontSize: 12 }}>Sans action, un achat est validé automatiquement après 48 h si le participant n'est ni suspect ni exclu. Un refus rend les miles et le stock.</p>
            </>
        );
    }

    renderDraws() {
        const { draws, entries, busy } = this.state;
        const conf = (this.props.challenge.lottery && this.props.challenge.lottery.draws) || [];
        return (
            <>
                <Button size="sm" variant="secondary" onClick={this.exportWinners} disabled={!draws.length}>Exporter les gagnants (CSV)</Button>
                {conf.map(d => {
                    const results = draws.filter(r => r.date === d.date).sort((a, b) => a.seq - b.seq);
                    const replaced = new Set(results.filter(r => r.replacedUserID).map(r => r.replacedUserID));
                    const urne = entries[d.date];
                    const drawn = results.some(r => r.seq === 0);
                    return (
                        <div key={d.date} style={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 12, margin: "12px 0" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                <strong>{Moment(d.date).format("dddd DD/MM")} — clôture {d.cutoffHour || 21} h — {(d.prizes || []).map(p => `${(p.label || {}).fr} ×${p.winners}`).join(", ")}</strong>
                                <span>
                                    <Button size="sm" variant="light" onClick={() => this.loadEntries(d.date)}>Voir l'urne</Button>{" "}
                                    <Button size="sm" variant="dark" disabled={drawn || busy === `draw-${d.date}`} onClick={() => this.draw(d.date)}>{drawn ? "Tiré" : "Tirer au sort"}</Button>
                                </span>
                            </div>
                            {urne ? (
                                <p className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                                    Urne : {urne.totalTickets} tickets, {urne.entries.filter(e => !e.blocked).length} participants
                                    {urne.entries.some(e => e.blocked) ? ` (+ ${urne.entries.filter(e => e.blocked).length} exclus/suspects hors urne)` : ""} —{" "}
                                    {urne.entries.slice(0, 15).map(e => `${e.displayName || e.userID} ${e.tickets}${e.blocked ? " ⛔" : ""}`).join(", ")}{urne.entries.length > 15 ? "…" : ""}
                                </p>
                            ) : null}
                            {results.map(r => (
                                <div key={r.seq} style={{ marginTop: 8 }}>
                                    <div className="text-muted" style={{ fontSize: 12 }}>
                                        {r.seq === 0 ? "Tirage" : `Tirage complémentaire n°${r.seq} (remplace ${r.replacedUserID})`} du {Moment(r.drawnAt).format("DD/MM HH:mm")} par {r.drawnBy} — {r.totalTickets} tickets, {r.candidates} candidats
                                        {Object.keys(r.unawarded || {}).length ? ` — non attribués : ${Object.entries(r.unawarded).map(([k, n]) => `${k} ×${n}`).join(", ")}` : ""}
                                    </div>
                                    <Table size="sm">
                                        <tbody>
                                        {r.winners.map(w => (
                                            <tr key={w.userID} style={replaced.has(w.userID) ? { textDecoration: "line-through", color: "#999" } : undefined}>
                                                <td>{w.prizeId}</td><td>{w.displayName}</td><td>{w.email}</td><td>{w.tickets} tickets</td>
                                                <td>{w.notified ? "notifié" : "email en attente"}</td>
                                                <td>{!replaced.has(w.userID) ? <Button size="sm" variant="outline-secondary" disabled={busy === `replace-${d.date}-${w.userID}`} onClick={() => this.replace(d.date, w)}>Remplacer</Button> : null}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </div>
                            ))}
                        </div>
                    );
                })}
            </>
        );
    }

    renderBaskets() {
        const { baskets, busy, testLink } = this.state;
        return (
            <>
                <Button size="sm" variant="secondary" disabled={busy === "test-basket"} onClick={this.testBasket}>Créer un lien de test</Button>
                {testLink ? <p style={{ marginTop: 8 }}><a href={testLink} target="_blank" rel="noopener noreferrer">{testLink}</a> <span className="text-muted">(aucune commande, ni Chat ni email)</span></p> : null}
                {baskets.map(b => (
                    <div key={b.userID + b.date} style={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 12, margin: "12px 0" }}>
                        <strong>{b.displayName}</strong> ({b.email}){b.test ? " — TEST" : ""} — {b.startedAt ? `démarré le ${Moment(b.startedAt).format("DD/MM HH:mm:ss")}` : "pas encore démarré"}
                        {b.finalizedAt ? ` — terminé` : ""} — total <strong>{(b.total || 0).toFixed(2)} €</strong>
                        <Table size="sm">
                            <tbody>
                            {b.items.map(it => (
                                <tr key={it.slug}><td>{it.name}</td><td>{it.size}</td><td>{it.merchant}</td><td>{it.price.toFixed(2)} €</td>
                                    <td><a href={safeHref(it.offerUrl)} target="_blank" rel="noopener noreferrer">offre</a></td></tr>
                            ))}
                            </tbody>
                        </Table>
                    </div>
                ))}
            </>
        );
    }

    renderBody() {
        return (
            <>
                {this.state.error ? <p style={{ color: "#c0392b" }}>{this.state.error}</p> : null}
                <Button variant="light" size="sm" onClick={this.refresh} style={{ marginBottom: 8 }}>Rafraîchir</Button>
                <Tabs defaultActiveKey="purchases" id={`challenge-shop-tabs-${this.id()}`}>
                    <Tab eventKey="purchases" title="Achats">{this.renderPurchases()}</Tab>
                    <Tab eventKey="draws" title="Tirages">{this.renderDraws()}</Tab>
                    <Tab eventKey="baskets" title="Paniers 1 minute">{this.renderBaskets()}</Tab>
                </Tabs>
            </>
        );
    }

    render() {
        const c = this.props.challenge;
        // inline : page « Boutique & loterie » de la barre de navigation (sinon modale depuis la liste des challenges).
        if (this.props.inline) return <div>{this.renderBody()}</div>;
        return (
            <Modal show={this.props.isOpen} onHide={this.props.closeModal} size="xl" centered>
                <Modal.Header closeButton><Modal.Title>Boutique &amp; loterie — {c.name}</Modal.Title></Modal.Header>
                <Modal.Body>{this.renderBody()}</Modal.Body>
                <Modal.Footer><Button variant="secondary" onClick={this.props.closeModal}>Fermer</Button></Modal.Footer>
            </Modal>
        );
    }
}
